export default {
    login: 'Iniciar sesión',
    registration: 'Registro',
    order: 'Mi pedido',
    language: 'español',
    home: 'Inicio',
    babyToys: 'Palabra clave',
    aboutus: 'Sobre nosotros',
    product: 'Producto',
    cart: 'Carrito',
    contactus: 'Contáctenos',
    comprehensiveInquiry: 'Consulta integral',
    advancedSearch: 'Búsqueda avanzada',
    productName: 'Nombre del producto',
    priceRange: 'Rango de precios',
    reset: 'Restablecer',
    search: 'Buscar',
    classify: 'Clasificar',
    categories: 'Categorías de productos',
    close: 'Cerrar',
    open: 'Expandir',
    updateTime: 'Tiempo de actualización',
    startTime: 'Hora de inicio',
    endTime: 'Hora de finalización',
    confirm: 'Confirmar',
    minimumPrice: 'Precio mínimo',
    highestPrice: 'Precio máximo',
    L: 'Largo',
    W: 'Ancho',
    H: 'Alto',
    inputPlaceholder: 'Por favor ingrese contenido',
    selectPlaceholder: 'Por favor seleccione',
    packingCapacity: 'Capacidad de empaque',
    price: 'Precio',
    itemNo: 'Número de fábrica',
    packing: 'Método de embalaje',
    productSize: 'Especificaciones del producto',
    packageSize: 'Especificaciones del paquete',
    cartonSize: 'Especificaciones de la caja exterior',
    innerBoxAndOuterPacking: 'Cantidad de caja interior / caja exterior',
    OuterPacking: "Cantidad de caja exterior",
    CBMAndCUFT: 'Volumen / Medida cúbica',
    CUFT: 'Medida cúbica',
    CBM: 'Volumen',
    GWAndNW: 'Peso bruto / Peso neto',
    mOQ: 'Cantidad mínima de pedido',
    productInformation: 'Información del producto',
    relatedProducts: 'Productos relacionados',
    more: 'Más',
    clear: 'Limpiar',
    inputPassword: 'Por favor ingrese la contraseña',
    passwordLength: 'La longitud de la contraseña no puede ser menor a 6 caracteres',
    inputUserName: 'Por favor ingrese el nombre',
    inputUserAccount: 'Por favor ingrese el nombre de usuario',
    inputVaildeCode: 'Por favor ingrese el código de verificación',
    inputMobile: 'Por favor ingrese el número de teléfono móvil',
    inputEmail: 'Por favor ingrese el correo electrónico',
    inputEmailRules: 'Formato de correo electrónico incorrecto',
    password: 'Contraseña',
    username: 'Nombre',
    vaildecode: 'Código de verificación',
    gender: 'Género',
    useraccount: 'Nombre de usuario',
    man: 'Hombre',
    woman: 'Mujer',
    mobile: 'Número de teléfono móvil',
    email: 'Correo electrónico',
    address: 'Dirección de contacto',
    CodeError: 'Error de código de verificación',
    resUserError: 'El nombre de usuario ya existe',
    notreviewed: 'Cuenta no revisada',
    loginError: 'Error en nombre de usuario o contraseña',
    loginSuccess: 'Inicio de sesión exitoso',
    regSuccess: 'Registro exitoso',
    deleteSuccess: 'Eliminación exitosa',
    toregister: '¿No tiene una cuenta? Regístrese',
    toLogin: '¿Ya tiene una cuenta? Inicie sesión',
    logout: 'Cerrar sesión',
    myShoppingCart: 'Mi carrito de compras',
    ID: 'Número de serie',
    picture: 'Imagen',
    ItemNO: 'Número',
    name: 'Nombre',
    total: 'Total',
    delete: 'Eliminar',
    CTNS: 'Cajas',
    checkAll: 'Seleccionar todo',
    checkSelect: 'Seleccionar todos en esta página',
    page: 'Página',
    goTO: 'Ir a',
    totalRecords: 'Número total de estilos',
    totalCTNS: 'Número total de cajas',
    totalQuantity: 'Cantidad total',
    totalPrice: 'Precio total',
    submit: 'Enviar',
    orderDetails: 'Detalles del pedido',
    OrderInformation: 'Información del pedido',
    number: 'Número',
    orderTime: 'Hora del pedido',
    linkman: 'Persona de contacto',
    remark: 'Observaciones',
    viewDetails: 'Ver detalles',
    companyContact: 'Persona de contacto',
    companyTel: 'Teléfono',
    companyFax: 'Fax',
    companyMail: 'Correo electrónico',
    companyAddress: 'Dirección',
    productCenter: 'Centro de productos',
    helpCenter: 'Centro de ayuda',
    member: 'Centro de miembros',
    productdemand: 'Demanda de productos',
    newproduct: 'Productos más nuevos',
    registerhelp: 'Ayuda de registro',
    orderhelp: 'Ayuda de pedidos',
    newproducts: 'Exhibición de nuevos productos',
    highRec: 'Productos recomendados',
    slogan: 'Productos con mayor volumen de ventas, más rápidos y mejor retroalimentación en 2023',
    viewmore: 'Ver más',
    videocenter: 'Centro de video',
    videoSlogan: 'Venga a conocer más a fondo la industria del juguete con nosotros',
    searchPicture: 'Búsqueda por imagen',
    choosePicture: 'Seleccionar imagen',
    clickOrDrag: 'Haga clic / Arrastre el archivo aquí',
    copyPicture: 'Copiar imagen: haga clic aquí, clic derecho pegar / Ctrl+V',
    pictureCrop: 'Área de recorte de imagen',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    pleaseLogin: 'Por favor inicie sesión',
    addCart: "Agregar al carrito",
    delCart: "Cancelar agregar al carrito",
    viewPrice: 'Ver precio',
    noData: 'Sin datos temporales',
    systemTip: 'Aviso del sistema',
    deleteData: '¿Eliminar estos datos?',
    clearCartData: '¿Vaciar todo el carrito de compras?',
    orderSuccess: '¡Pedido creado con éxito!',
    submitTip: '¿Confirmar envío del pedido?',
    noLogin: 'Por favor inicie sesión antes de agregar al carrito',
    notImage: 'El contenido pegado no es una imagen',
    noSelect: 'Por favor seleccione datos',
    hotSaleProduct: 'Productos populares',
    popularRecommendation: 'Recomendaciones populares',
    please_contact_us: 'Si tiene alguna pregunta, no dude en enviarnos un fax o llamarnos',
    ock_email: 'Correo electrónico',
    contactUs: 'Contáctenos',
    hotLine: 'Línea directa',
    companyAddres: 'Dirección de la empresa',
    workingHours: 'Horario de oficina',
    week: 'De lunes a viernes',
    companyInfo: 'Perfil de la empresa',
    noName: 'Sin traducción temporal',
    serviceHotine: "Servicio de línea directa 24 * 7",
    success: "Agregado exitosamente",
    del: "Eliminado exitosamente",
    orderStatus: 'Estado del pedido',
    sendDate: 'Fecha de envío',
    expressNumber: 'Número de seguimiento',
    unshipped: 'No enviado',
    shipped: 'Enviado',

    Disclaimer: "Descargo de responsabilidad: Todas las imágenes y productos en este sitio web son de los fabricantes, los derechos de autor pertenecen a los fabricantes.",
    Technic: 'Soporte técnico',
    Software: 'Shenzhen Hongsheng Software Technology Development Co., Ltd.',
    coNuNum: "Número de empresa",
    all: 'Todas las categorías',
    userAddress: 'Dirección de entrega',
    consignee: 'Destinatario',
    addressDetail: 'Dirección detallada',
    addressinformation: 'Información de dirección de entrega',
    defaultAddress: 'Por defecto',
    defaultSettings: 'Establecer como predeterminado',
    edit: 'Editar dirección',
    add: 'Agregar dirección',
    AddinganAddress: 'Agregar dirección',
    Edittheaddress: 'Editar dirección',
    Ok: 'Guardar',
    Address_Consignee: 'Por favor ingrese el destinatario',
    Address_Mobile: 'Por favor ingrese el número de teléfono móvil',
    Address_Address: 'Por favor ingrese la dirección',
    PleaseContact: 'Por favor ingrese la persona de contacto',
    Video_playback: 'Reproducción de video',
    "DK.navTitle.Home": "Inicio",
    "DK.navTitle.Produch": "Exhibición",
    "DK.navTitle.Cart": "Carrito",
    "DK.navTitle.Exhibition": "Plan de exposición",
    "DK.navTitle.Message": "Contacto / Sobre nosotros",
    "DK.logoBox.placeholder": "Por favor ingrese la palabra clave del producto",
    "DK.ProductNumber": "Número de producto",
    "DK.amount": "Cantidad",
    "DK.contactUs": "Contáctenos",
    "DK.understandDeke": "Conocer Deke",
    "DK.aboutUs": "Sobre nosotros",
    "DK.telephone": "Teléfono fijo",
    "DK.phoneAndWeixin": "Teléfono móvil y WeChat",
    "DK.PleaseOrderNum": "Por favor ingrese el número de pedido",
    "DK.ArticleNo": "Número de artículo",
    "DK.TotalVolume": "Volumen total",
    "DK.totalQTY": "Cantidad total",
    "DK.totalItems": "Número total de estilos",
    "DK.ExhibitionRelatedProducts": "Productos relacionados con la exposición",
    "DK.ProductsVideo": "Video del producto",
    "DK.ReleaseDate": "Fecha de lanzamiento",
    "DK.inquirySheet": "Hoja de consulta",
    "DK.SendInquiry": "Enviar hoja",
    "DK.productPrice": "Precio del producto",
    "DK.OuterBoxCBM": "Volumen de la caja exterior",
    "DK.OuterBoxCUFT": "Medida cúbica de la caja exterior",
    "DK.Innerboxes": "Número de cajas interiores",
    "DK.OuterCapacity": "Capacidad de la caja exterior",
    "DK.productDetails": "Detalles del producto",
    "DK.similarProduct": "Productos similares",
    "DK.MyRFQ": "Mi hoja de consulta",
    "DK.enquiry": "Consulta",
    "DK.enquirys": "Por favor deje su correo electrónico, nos pondremos en contacto con usted",
    "DK.contact": "Información de contacto",
    "DK.Description": "Nombre",
    "DK.OuterQTY": "Cantidad",
    "DK.LastSevenDays": "Últimos",
    "DK.All": "Todos",
    "DK.PleaseEmial": "Por favor ingrese el correo electrónico",
    "DK.PleaseCode": "Por favor ingrese el código de verificación",
    "DK.PleasePhone": "Por favor ingrese el número de teléfono móvil",
    "DK.PleaseName": "Por favor ingrese el nombre de usuario",
    "DK.userName": "Nombre de usuario",
    "DK.PleaseAddress": "Por favor ingrese la dirección de contacto",
    "DK.HighRec": 'Productos populares',
}